import script from "./AssignmentRoutes.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignmentRoutes.vue?vue&type=script&setup=true&lang=js"

import "./AssignmentRoutes.vue?vue&type=style&index=0&id=104b4a16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104b4a16"]])

export default __exports__